const keys = {
  occupation: {
    choices: {
      accounting: 'Accounting',
      actuarial: 'Actuarial',
      banking: 'Banking',
      clscStaff: 'CLSC Staff',
      dentist: 'Dentist',
      doctor: 'Doctor',
      federalGovernment: 'Federal Government',
      hospitalStaff: 'Hospital Staff',
      insurance: 'Insurance',
      lawyer: 'Lawyer',
      municipalGovernment: 'Municipal Government',
      notary: 'Notary',
      nurse: 'Nurse',
      other: {
        finance: 'Other',
        generic: 'Other',
        law: 'Other',
        medical: 'Other',
        publicCivilServices: 'Other (fire fighter, postal worker, etc)',
      },
      policeOfficer: 'Police Officer',
      provincialGovernment: 'Provincial Government',
      technician: 'Technician',
    },
    subtitle: 'Some extra discounts are available for you! Choose the occupation that best describes your work.',
    suggestionTitle: 'Select a field of work',
  },
};

export default keys;

export type TranslationKeys = typeof keys;
